<template>
  <div v-if="styleType === 'normal'">
    <div v-for="(option, index) in inputData.radio" v-bind:key="index">
      <label>
        <input
          type="radio"
          v-bind:name="inputData.label"
          v-bind:value="option.value"
          v-bind:checked="value === option.value"
          v-on:click="updateValue(option.value)">
        <span class="text">{{ option.value }}</span>
      </label>
    </div>
    <div class="validation-text" v-if="status === true">
      {{ t.pleaseSelectOption }}
    </div>
  </div>
  <div v-else-if="styleType === 'material'">
    <div v-for="(option, index) in inputData.radio" v-bind:key="index">
      <label class="rp-material-radio">
        <input type="radio"
          v-bind:name="inputData.label"
          v-bind:value="option.value"
          v-bind:checked="value === option.value"
          v-on:click="updateValue(option.value)"
          class="rp-radio">
        <span class="text">{{ option.value }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'RadioInput',
  props: {
    value: String,
    styleType: {
      type: String,
      default: 'normal'
    },
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 0,
          type: 'radio',
          label: 'radio1',
          required: '0',
          placeholder: 'placeholder',
          radio: [
            {
              id: 1,
              value: 'Option1'
            },
            {
              id: 2,
              value: 'Option2'
            }
          ]
        }
      }
    }
  },
  data () {
    return {
      status: false
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseSelectOption: 'Please select an option'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseSelectOption: 'กรุณาเลือกรายการ'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseSelectOption: 'Vui lòng chọn một mục'
        }
      }
    }
  },
  methods: {
    validateInput () {
      let result = true

      if (this.value === '' && this.inputData.required === '1') {
        this.status = true
        result = false

        return result
      } else {
        this.status = false
      }

      return result
    },
    updateValue (value) {
      this.$emit('input', value)
      this.status = false
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  position: absolute;
  margin-top: 3px;
}
.text {
  width: 90%;
  overflow-wrap: break-word;
  display: inline-block;
  margin-left: 20px;
}
.validation-text {
  color: red;
  font-size: 0.75em;
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/RadioInput.vue